<template>
    <div>
        <Breadcrumb class="breadcrumb">
            <BreadcrumbItem class="click" to="/teachAdmin/contestAdmin/index">
                竞赛管理
            </BreadcrumbItem>
            <BreadcrumbItem>新增镜像</BreadcrumbItem>
        </Breadcrumb>
        <Form :model="createForm" ref="createForm" :rules="ruleValidate" label-position="left" :label-width="110">
            <div class="create-box">
                <div class="create-box-title">
                    <h3>基本信息</h3>
                </div>
                <FormItem label="镜像类型" v-if="mcpInfo.mcp_type_name != '' ">
                    {{mcpInfo.mcp_type_name}}
                </FormItem>
                <FormItem label="镜像类型" v-else>
                    未选择环境不可创建
                </FormItem>

                <FormItem label="镜像名称" class="form-item" prop="name">
                    <Input v-model="createForm.name" style="width: 200px" placeholder="请输入镜像名称"></Input>
                </FormItem>
                <br />
                <FormItem label="基础镜像" class="form-item" prop="base_image_id">
                    <Button @click="selectImages">{{commonImagesName}}</Button>
                </FormItem>
                <br />
                <FormItem label="镜像描述" prop="remark">
                    <Input v-model="createForm.remark" type="textarea" style="width:400px;"
                           placeholder="请输入描述信息"></Input>
                </FormItem>
                <br />
            </div>
            <div class="create-box">
                <div class="create-box-title">
                    <h3>自定义</h3>
                </div>
                <FormItem :label="index" class="form-item" v-for="(value,index) in env_mod_list">
                    <div v-if="value.length > 0">
                        <FormItem v-for="(item,idx) in value ">
                            <Input placeholder="包名" v-model="item.mod" style="width:10%;"></Input> ==
                            <Input placeholder="版本号" v-model="item.ver"  style="width:10%;" ></Input>
                            <Icon type="md-close" size="20" @click="closeCustom(index,idx)"/>
                            <br />
                        </FormItem>
                    </div>

                    <br v-if="value.length > 0"/>
                    <Button @click="addCustom(index)">+ 添加</Button>
                </FormItem>
                <Button type="primary" @click="build" v-if="mcpInfo.mcp_type_name != '' ">构建</Button>
            </div>
        </Form>

        <!-- 基础镜像-->
        <Modal
                v-model="showCommonEnv"
                title="选择基础镜像"
                width="700"
        >
        <List border>
            <RadioGroup v-model="createForm.base_image_id"  style="width:100%;">
                <ListItem @click.native="selectCommonImages(item.id,item.name,item.languages)" v-for="item in commonList.body" style="cursor:pointer;" v-show="item.language != '' ">
                    <Radio :label="item.id">
                        <span>{{item.name}}</span>
                    </Radio>
                </ListItem>
            </RadioGroup>
        </List>
        </Modal>
        <!--竞赛环境结束-->

    </div>
</template>
<script>
    import {mapState,mapActions} from 'vuex'
    export default {
        name:"createImages",
        computed:{
            ...mapState({
                commonList: state => state.images.publicList,
            })
        },
        data(){
            return {
                ruleValidate:{
                    name:[
                        { required: true, message: '镜像名称必填', trigger: 'blur' },

                    ],
                    base_image_id:[
                        { required: true, message: '基础镜像必填', trigger: 'blur',type:'number' },

                    ],
                    remark:[
                        { required: true, message: '镜像描述必填', trigger: 'blur' },
                    ]
                },
                mcpInfo:{'mcp_type':{name:''}},
                commonImagesName:"选择基础镜像",
                radioId:"",
                showCommonEnv:false,
                index:0,
                env_mod_list:{},
                createForm:{
                    name:'',
                    env_mod:{},
                    base_image_id:'',
                    remark:'',
                },
            }
        },
        methods:{
            ...mapActions({
                getCommonImageList:'images/getPublicImagesList',
                createPrivateImage:'images/createPrivateImage',
                get_availableSvc:'common/get_availableSvc'
            }),
            closeCustom(index,idx){
                this.env_mod_list[index].splice(idx,1);
            },
            addCustom(language){
                this.index++;
                this.env_mod_list[language].push(
                    {
                        mod:'',
                        oper:'==',
                        ver:'',
                        index: this.index,
                    }
                )
            },
            selectCommonImages(radioId,name,language){
                if(language == undefined){
                    return false;
                }
                this.createForm.base_image_id = radioId;
                this.commonImagesName = name;
                let languageList = {};
                language.forEach((item) =>{
                    languageList[item] = [];
                });
                this.env_mod_list = languageList;
            },
            selectImages(){
                this.showCommonEnv = true;
                this.getCommonImageList({
                    data:{
                        sort:'ctime',
                        channel:2,
                        page_num:1,
                        page_size:1000
                    }
                })
            },
            build(){
                // 验证
                this.$refs['createForm'].validate((valid) => {
                    if (valid) {
                        let check = false;
                        for(var i in this.env_mod_list){
                            if(this.env_mod_list[i].length > 0){
                                check = true;
                            }
                            for(let value in this.env_mod_list[i]){
                                if(this.env_mod_list[i][value].mod==""){
                                    this.$Message.error("自定义模块不能为空");
                                    return false;
                                }
                            }
                        }
                        if(!check){
                            this.$Message.error("请填写模块名称");
                            return false;
                        }
                        this.createForm.env_mod = JSON.stringify(this.env_mod_list);
                        this.createPrivateImage({
                            url:this.mcpInfo.mcp_endpoint.domain_name,
                            data:this.createForm,
                            callback:res=>{
                                this.$Message.success('创建成功');
                                this.$router.push({
                                    name: 'Contestlist',
                                    params: {current: 'imagesList'}
                                })
                            },
                            error:res=>{
                                this.$Message.success(res.message);
                            },
                        });
                    } else {
                        this.$Message.error('请填写完整内容');
                    }
                })
            }
        },
        created(){
            let mcpId = this.$route.params.mcpid;
            let _this = this;
            if(mcpId != undefined && mcpId > 0){
                // 获取可用节点
                this.get_availableSvc({
                    callback:res=>{
                        res.forEach(item=>{
                            if(item.mcp_type === parseInt(mcpId)){
                                _this.mcpInfo = item;
                            }
                        })
                    }
                })
            }
        }
    }
</script>
<style scoped lang="less">
    @import "../../style/index";
    @import "../../../../assets/style/exercises";
</style>
